<template>

    <div class="okno_full">
                <div class="headnot">
                    <div class="logo-icon" @click="uioknoClose()">X</div>
                    <h5>{{ props.text }}</h5>
                    
                </div>
                    <div class="conents_okno">
                        <slot/>
                    </div>
                </div>

</template>

<script setup>
const props = defineProps(['close', 'text'])
const uioknoClose = () => { props.close() }
</script>

<style scoped>
.logo-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--accent-black);
  border-radius: 100%;
  transition: background-color 0.3s;
  color: #ffffff;
}

html.dark .logo-icon {
  background-color: var(--action-btn-bg);  
}
</style>
